<template>
  <section>
    <DonateContentSectionIdeal />
    <DonateContentSectionManual />
    <DonateContentSection title="PayPal" icon="bx:donate-heart">
      <DonateButtonPaypal />
    </DonateContentSection>
    <DonateContentSection title="Spullen" icon="bx:donate-heart">
      <p class="leading-6">
        Doneer je liever spullen zoals een goede lamp, een nieuwe camera of iets anders? Neem dan contact met ons op via
        <ULink to="/contact" class="light:text-primary-600 light:hover:text-primary-500 dark:text-primary-200 dark:hover:text-primary-100">
          het contactformulier
        </ULink>.
      </p>
    </DonateContentSection>
  </section>
</template>
